const wheelsMetaData = [
  {
    className: 'tesla-wheel',
    title: 'Tesla Model S Front Wheel',
    alt: 'Tesla Model S Front Wheel',
    srcset: {
      min: 'assets/images/car-wheel@2x.png',
      max: 'assets/images/car-wheel.png',
    },
  },
  {
    className: 'tesla-wheel',
    title: 'Tesla Model S Rear Wheel',
    alt: 'Tesla Model S Rear Wheel',
    srcset: {
      min: 'assets/images/car-wheel@2x.png',
      max: 'assets/images/car-wheel.png',
    },
  },
];

const Illustration = () => `
    <section class="illustration" role="region">
        <picture class="tesla-car-skeleton">
            <source media="(min-width: 49rem)" srcset="assets/images/car-base@2x.png" alt="Tesla Model S" title="Tesla Model S" />
            <img src="assets/images/car-base.png" alt="Tesla Model S" title="Tesla Model S" />
        </picture>
        ${wheelsMetaData
          .map(
            ({ className, title, alt, srcset }) => `
            <picture class="${className}">
                <source media="(min-width: 49rem)" srcset="${srcset.min}" alt="${alt}" title="${title}" />
                <img src="${srcset.max}" alt="${alt}" title="${title}" />
            </picture>
        `
          )
          .join('')}
    </section>
`;

export default Illustration;
